import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubsidiaryService } from '../../services/subsidiary.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-read-subsidiary',
    templateUrl: './read-subsidiary.component.html',
    styleUrls: ['./read-subsidiary.component.css']
})

export class ReadSubsidiaryComponent implements OnInit, OnDestroy {

    subsidiaries: any[] = [];

    sub: Subscription;

    constructor(private service: SubsidiaryService) {
        this.loadSubsidiaries();
    }

    ngOnInit() {
    }
    ngOnDestroy(){
        this.sub.unsubscribe();
    }

    loadSubsidiaries() {
        this.sub = this.service.getSubsidiaries().subscribe(subsidiaries => {
            this.subsidiaries = subsidiaries;
        });
    }

    deleteSubsidiary(id$) {
        this.service.delSubsidiary(id$);
        this.loadSubsidiaries();
    }

}
